import { Box, Button } from '@wix/design-system';
import classNames from 'classnames';

import css from './index.module.scss';

type RelatedQuestionsSliderProps = {
  relatedQuestions: string[];
  onQuestionClick?: (question: string, index: number) => void;
  embedded?: boolean;
};

export const RelatedQuestionsSlider = ({
  relatedQuestions,
  onQuestionClick,
  embedded = false,
}: RelatedQuestionsSliderProps) => (
  <Box className={classNames(css.wrapper, { [css.embedded]: embedded })}>
    <Box className={css.sliderContainer}>
      {relatedQuestions.map((question, index) => (
        <Button
          key={question}
          size="tiny"
          className={css.tag}
          onClick={() => onQuestionClick?.(question, index)}
        >
          {question}
        </Button>
      ))}
    </Box>
  </Box>
);
